export const PROFILE_STATUS_OPTIONS = [
  'new',
  'completed',
  'pending',
  'verification',
  'limited',
  'verified',
  'disabled',
];

export const PROFILE_FILTER_FIELDS = Object.freeze({
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  status: 'status',
});

export const PROFILE_SORT_ORDER_OPTIONS = Object.freeze({
  asc: 'asc',
  desc: 'desc',
});

export const PROFILE_SORTABLE_COLUMNS = Object.freeze({
  name: 'fullName',
  email: 'email',
  country: 'country',
  created: 'created',
});

export const PARTNER_STATUS_OPTIONS = [
  { value: '', label: 'enum.allStatuses' },
  { value: 'pending', label: 'enum.pending' },
  { value: 'active', label: 'enum.active' },
  { value: 'suspended', label: 'enum.suspended' },
  { value: 'terminated', label: 'enum.terminated' },
];

export const COMMISSION_TYPE_OPTIONS = [
  { value: '', label: 'enum.allTypes' },
  { value: 'cpa', label: 'enum.cpa' },
  { value: 'lot_rebate', label: 'enum.lotRebate' },
];

export const COMMISSION_STATUS_OPTIONS = [
  { value: '', label: 'enum.allStatuses' },
  { value: 'pending', label: 'enum.pending' },
  { value: 'approved', label: 'enum.approved' },
  { value: 'paid', label: 'enum.paid' },
  { value: 'cancelled', label: 'enum.cancelled' },
];

export const COMMISSION_TIER_TYPE_OPTIONS = [
  { value: 'cpa', label: 'enum.cpa' },
  { value: 'lot_rebate', label: 'enum.lotRebate' },
];

export const LEAD_STATUS_OPTIONS = [
  'new',
  'contacted',
  'engaged',
  'qualified',
  'scheduled',
  'unresponsive',
  'converted',
  'not-interested',
  'duplicate',
  'nurturing',
  'rejected',
  'do-not-contact',
];

export const LEAD_COLLECTION_SOURCE_OPTIONS = [
  'business_card',
  'conference',
  'landing_form',
  'referral',
  'manual',
  'other',
];

export const LEAD_LAWFUL_BASIS_OPTIONS = [
  'consent',
  'legitimate_interest',
  'contract_preparation',
  'legal_obligation',
  'unknown',
];

export const LEAD_CONSENT_STATUS_OPTIONS = [
  'not_requested',
  'given',
  'declined',
  'withdrawn',
];

export const LEAD_PRIVACY_NOTICE_STATUS_OPTIONS = [
  'pending',
  'sent',
  'acknowledged',
  'not_required',
];

export const LEAD_SORTABLE_COLUMNS = Object.freeze({
  created: 'created',
  phone: 'phone',
  status: 'status',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  country: 'country',
  language: 'language',
  collectionSource: 'collectionSource',
  lawfulBasis: 'lawfulBasis',
  privacyNoticeStatus: 'privacyNoticeStatus',
});
